import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActionIconDef, Grid as InavistaGrid, GridActionIconClickEvent, GridConfig, GridHyperlinkClickEvent, GridRow } from '@inavista/components/grid';
import { CommonService } from 'projects/service/src/app/shared/services/common.service';
import { ApiResponse, LinksEnum, paymentMethodType, UserRoles } from 'projects/service/src/app/shared/models/app.model';
import { IscService } from '../../../services/isc.service';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { PurchaseOrderModel, PurchaseOrderStatus } from 'projects/service/src/app/shared/models/purchaseOrder.model';
import { InventoryService } from '../../../services/inventory.service';
import { ServiceOrderService } from 'projects/service/src/app/modules/service-order/services/service-order.service';
import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';
import { MasterItemcodePopupComponent } from 'projects/shared/src/lib/components/master-itemcode-popup/master-itemcode-popup.component';
import { LocalRowsGridApi, provideLocalGridRows } from 'projects/service/src/app/shared/utils/local-rows-grid-api';
import { statusPillColor } from 'projects/service/src/app/shared/utils/status-pill-colors';
import {
  buildCancelActionIcons, buildCheckoutItemsActionIcons, buildCheckoutItemsGridConfig, buildOrderedItemsGridConfig,
  buildTrackingUpdatesGridConfig, CHECKOUT_ITEMS_COLUMNS, CHECKOUT_ITEMS_URL, ORDERED_ITEMS_COLUMNS, ORDERED_ITEMS_URL,
  TRACKING_UPDATES_COLUMNS, TRACKING_UPDATES_URL,
} from './cart-checkout.grid.config';

// Ordered Items and Tracking Updates had no height (auto): as tall as their rows. No paging now (Martin): up to 20
// rows, then they scroll. Header + horizontal scrollbar, and the row height of the config.
const GRID_CHROME_PX = 52;
const ROW_PX = 30;
const MAX_VISIBLE_ROWS = 20;
const MIN_VISIBLE_ROWS = 2;
const gridHeightFor = (rows: number) => GRID_CHROME_PX + Math.min(Math.max(rows, MIN_VISIBLE_ROWS), MAX_VISIBLE_ROWS) * ROW_PX;

@Component({
    selector: 'app-cart-checkout-popup',
    templateUrl: './cart-checkout-popup.component.html',
    styleUrls: ['./cart-checkout-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    // The three grids read this popup's own arrays, not an endpoint.
    providers: [...provideLocalGridRows()]
})
export class CartCheckoutPopupComponent implements OnInit {
  private readonly gridRows = inject(LocalRowsGridApi);

  purchaseOrderData: PurchaseOrderModel;

  isExpanded: boolean = true;
  @Output() onClose = new EventEmitter();
  @Output() onLinkIdClick = new EventEmitter();
  @Input() tab: string = 'details';
  @Input() box;
  @Input() showComments: boolean = false;
  /**Input from service order */
  @Input() serviceOrderId: string;
  @ViewChild('address') address: DropDownList;
  @ViewChild('shipmentMethodDDLRef') shipmentMethodDDL: DropDownList;

  PurchaseOrderStatus: typeof PurchaseOrderStatus = PurchaseOrderStatus;

  @Input() recievedItems: any = [];
  @Input() singleRecievedItem: any;
  @Input() onsiteAddress: any;
  purchaseOrderId: any;
  taxRatePercentage: any;
  taxMessage;
  isIscSupervisor: boolean = false;
  soldToBp: any;
  USER: any;
  isAdmin: boolean;

  constructor(private commonService: CommonService,
    private iscService: IscService,
    private inventoryService: InventoryService,
    private cdr: ChangeDetectorRef,
    private serviceOrderService: ServiceOrderService,
    private router: Router,
    private dialog: MatDialog) {
    this.USER = this.commonService.USER;
    this.isAdmin = this.USER.role === UserRoles.administratorRole;
  }

  showMasterItemCodePopup(eqData: any) {
    if (!eqData?.itemCode && !eqData?.item) return;
    const dialogRef = this.dialog.open(MasterItemcodePopupComponent, {
      panelClass: 'master-itemcode-popup-dialog',
      width: '80%',
      height: '80%',
      data: eqData
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  data: any;
  showLoader: boolean = false;
  orderedGridHeight: number = gridHeightFor(0);
  trackingGridHeight: number = gridHeightFor(0);
  commentCount = 0;
  attachmentCount = 0;

  mainGrid: any;
  allowRowEdit: boolean = false;

  showChasePaymentIframe: boolean = false;
  disablePaymentButton: boolean = true;

  userDetails;
  technicianAddresses: any;
  shipmentMethodsList: any = [];
  // showCartCheckoutPopup: boolean = false;
  isIsc: boolean;
  isIscManager: boolean;
  isSM: boolean;
  isCSA: boolean;

  poRefFlag: boolean = false;

  totalNetPrice: any = 0;
  shippingCost: number = 0;
  tax: number = 0;
  shipmentDDLFlag: boolean = false;
  public paymentOptionsDDL = ['Credit Card', 'On Account'];
  @ViewChild('addressesDropdown') addressesDropdown: DropDownList;
  public checkType: string = 'onSiteAdress';
  @ViewChild('POCheckoutGrid') grid: InavistaGrid;
  @ViewChild('OrderedItemsGrid') orderedItemGrid: InavistaGrid;
  @ViewChild('TrackingUpdatesGrid') trackingGrid: InavistaGrid;
  @ViewChild('trackingIdCell', { static: true }) trackingIdCell: TemplateRef<unknown>;

  checkoutItemsConfig: GridConfig = null;
  orderedItemsConfig: GridConfig = null;
  trackingUpdatesConfig: GridConfig = null;
  checkoutItemsActionIcons: ActionIconDef[] = [];
  orderedItemsActionIcons: ActionIconDef[] = [];
  trackingUpdatesActionIcons: ActionIconDef[] = [];
  /** The objects each grid shows, by row key: the popup's own items (the old handlers' rowData). */
  private checkoutRowItems: any[] = [];
  private orderedRowItems: any[] = [];
  private trackingRowItems: any[] = [];
  toArray: any;
  showGrid: boolean = false;
  trackingTabDataSource: any;
  orderedTabDataSource: any
  links: any;
  popupTitle: string;
  deleteDisableFlag: boolean = false;
  historyData: any = []

  orderedTabItemStatus: any
  trackingTabItemStatus: any
  noOrderFlag: boolean = false;
  noTaxFlag: boolean = false;
  currency;
  shipmentargs: any;
  showCustomerAdvancedSearchPopup: boolean = false;


  ngOnInit(): void {
    this.showLoader = true;
    this.checkType = !this.serviceOrderId && 'userAddress' || this.checkType;
    this.userDetails = this.commonService.USER;
    this.isIsc = this.commonService.USER.role === UserRoles.isc;
    this.isIscManager = this.commonService.USER.role === UserRoles.iscManager;
    this.isIscSupervisor = this.commonService.USER.role === UserRoles.IscSupervisor;
    this.isSM = this.commonService.USER.role === UserRoles.conwayServiceManager;
    this.isCSA = this.commonService.USER.role === UserRoles.csa;
    this.popupTitle = this.recievedItems[0]?.partsOrderId || 'Order (Checkout)';
    this.iscService.getSoldToBPById(this.userDetails?.iscCode).subscribe((res: any) => {
      this.soldToBp = res;
      if (this.soldToBp?.termsOfPayment === 'P01') {
        this.paymentOptionsDDL = ['Credit Card'];
      }
    })

    if (this.recievedItems.length === 1) {
      this.deleteDisableFlag = true;
    }
    this.setPurchaseOrderData();
    this.iscService.getTax(this.userDetails.employeeId).subscribe((res: ApiResponse) => {
      if (res?.isSuccessful) {
        this.taxRatePercentage = res?.result?.taxRatePercentage;
      }
      else {
        this.noTaxFlag = true;
        this.taxMessage = res.message;
        this.taxRatePercentage = 0.00;
      }

      if (this.recievedItems[0]?.comingFrom) {                //Case 1: coming from buy now
        this.fromBuyNow();
      } else if (this.recievedItems[0]?.assignmentId) {       //Case 2: coming from service order
        this.fromServiceOrder();
      } else if (this.recievedItems[0]?.partsOrderId) {       //Case 3: already created partsOrder id
        this.fromExistingPurchaseOrder();
      } else {                                                //Case 4: creation of purchase order
        this.creationMode();
      }

    })

    this.setupGrids();
  }

  onCustomerAdvancedSearchPopupClose(address: any) {
    this.showCustomerAdvancedSearchPopup = false;
    if (address) {
      this.checkType = 'userAddress';
      (this.addressesDropdown.dataSource as any).push(address);
      this.addressesDropdown.refresh();
      this.addressesDropdown.value = address.addressCode;
    }
  }

  fromBuyNow() {
    // "Case 1 : Buy now";
    this.purchaseOrderData['paymentMethod'] = this.soldToBp?.termsOfPayment === 'P01' ? paymentMethodType.creditCard : paymentMethodType.onAccount;
    if (this.noTaxFlag) {
      this.commonService.showNotification('error', this.taxMessage);
    }
    const item = this.recievedItems[0]?.item;
    const quantity = this.recievedItems[0]?.orderQty;
    this.iscService.refreshPrice(item, quantity).subscribe((res: ApiResponse) => {

      this.recievedItems[0].quantity = res?.result?.result?.orderedQuantity?.orderedQuantityValue;
      this.recievedItems[0].itemPrice = res?.result?.result?.bookPrice?.bookPriceValue;
      this.recievedItems[0].grossAmount = res?.result?.result?.grossAmount?.grossAmountValue;
      this.recievedItems[0].itemDiscount = res?.result?.result?.discountAmount?.discountAmountValue;
      this.recievedItems[0].netPrice = res?.result?.result?.netAmount?.netAmountValue;
      this.recievedItems[0].lineNumber = 1;
      this.totalNetPrice = this.recievedItems[0].netPrice ? this.recievedItems[0].netPrice : 0;
      this.tax = this.totalNetPrice * (this.taxRatePercentage / 100);

      setTimeout(() => {
        this.getShipmentDDL();
        this.getTechnicianAddress();
        this.shipmentMethodDDL.value = this.purchaseOrderData?.shipmentMethodCode;
        this.purchaseOrderData.shipmentMethodDescription = this.shipmentMethodDDL?.text;
      }, 1000);
      this.showLoader = false;
      this.refreshCheckoutRows();
      this.showGrid = true;
    })
  }

  fromServiceOrder() {
    // "Case 2 : from service order >> ", this.recievedItems[0]

    this.purchaseOrderData['paymentMethod'] = this.soldToBp?.termsOfPayment === 'P01' ? paymentMethodType.creditCard : paymentMethodType.onAccount;
    if (this.noTaxFlag) {
      this.commonService.showNotification('error', this.taxMessage);
    }
    this.getTechnicianAddress();
    this.iscService.refreshPrice(this.recievedItems[0]?.itemCode, this.recievedItems[0]?.qty).subscribe((res: any) => {
      if (res?.isSuccessful) {
        this.recievedItems[0].item = this.recievedItems[0]?.itemCode;
        this.recievedItems[0].quantity = res.result?.result?.orderedQuantity?.orderedQuantityValue;
        this.recievedItems[0].itemDiscount = res.result?.result?.discountAmount?.discountAmountValue;
        this.recievedItems[0].grossAmount = res.result?.result?.grossAmount?.grossAmountValue;
        this.recievedItems[0].itemPrice = res.result?.result?.bookPrice?.bookPriceValue;
        this.recievedItems[0].netPrice = res.result?.result?.netAmount?.netAmountValue;
        this.totalNetPrice = this.recievedItems[0].netPrice ? this.recievedItems[0].netPrice : 0;
        this.tax = this.totalNetPrice * (this.taxRatePercentage / 100);
      }
      
      this.recievedItems = this.recievedItems?.filter((item: any, index) => {
        item.lineNumber = index + 1;
        item.item = item.itemCode;
        item.itemTotal = item.netPrice * item.quantity;
        if (item.lineNumber === this.recievedItems.length) {
          this.tax = this.totalNetPrice * (this.taxRatePercentage / 100)
        }
        return !item.isDeleted;
      });
      setTimeout(() => {
        const address = this.checkType === 'onSiteAdress' ? this.onsiteAddress : this.technicianAddresses[0];
        this.setAddress(address);
        this.getShipmentDDL();
      }, 1000);
      this.showLoader = false;
      this.refreshCheckoutRows();
      this.showGrid = true;
    })
  }

  fromExistingPurchaseOrder() {
    this.purchaseOrderId = this.recievedItems[0]?.partsOrderId;
    this.getPurchaseOrderById();
    this.showGrid = true;
  }

  creationMode() { // from cart icon in toolbar
    // "Case 4 : creation mode >> ", this.recievedItems
    this.purchaseOrderData['paymentMethod'] = this.soldToBp?.termsOfPayment === 'P01' ? paymentMethodType.creditCard : paymentMethodType.onAccount;
    if (this.noTaxFlag) {
      this.commonService.showNotification('error', this.taxMessage);
    }
    this.recievedItems = this.recievedItems?.filter((item: any, index) => {
      return !item.isDeleted;
    });

    this.recievedItems.forEach((item, index) => {
      item.lineNumber = index + 1;
      item.itemTotal = item.netPrice * item.quantity;
      this.totalNetPrice += item.netPrice ? item.netPrice : 0;
      if (item.lineNumber === this.recievedItems.length) {
        this.tax = this.totalNetPrice * (this.taxRatePercentage / 100)
      }
    });
    setTimeout(() => {
      this.getShipmentDDL();
      this.getTechnicianAddress();

      this.shipmentMethodDDL.value = this.purchaseOrderData?.shipmentMethodCode;
      this.purchaseOrderData.shipmentMethodDescription = this.shipmentMethodDDL?.text;
    }, 1000);
    this.showLoader = false;
    this.refreshCheckoutRows();
    this.showGrid = true;
  }

  getPurchaseOrderById() {
    this.showLoader = true;
    this.poRefFlag = true;
    forkJoin([
      this.iscService.getPurchaseOrderById(this.purchaseOrderId),
      this.commonService.getLinkedRecords(LinksEnum.purchaseOrder, this.purchaseOrderId)
    ]).subscribe((res: any) => {
      if (res[0].isSuccessful) {
        this.purchaseOrderData = res[0]?.result;
        this.iscService.getSoldToBPById(this.purchaseOrderData?.soldToBP).subscribe((res: any) => {
          this.soldToBp = res;
          if (this.soldToBp?.termsOfPayment === 'P01') {
            this.paymentOptionsDDL = ['Credit Card'];
          }
        })
        this.historyData = res[0]?.result?.history;
        this.links = res[1]?.result;
        this.orderedTabDataSource = res[0]?.result?.itemList;

        this.orderedTabDataSource.forEach((el: any) => {
          this.orderedTabItemStatus = el.status;
        });

        this.trackingTabDataSource = res[0]?.result?.trackingList
        this.trackingTabDataSource.forEach((el: any) => {
          this.trackingTabItemStatus = el.status;
        });

        this.recievedItems = res[0]?.result?.itemList
        this.refreshCheckoutRows();
        this.refreshOrderedRows();
        this.refreshTrackingRows();
        this.totalNetPrice = this.purchaseOrderData?.amount;
        this.tax = this.purchaseOrderData?.tax;
        this.commentCount = this.purchaseOrderData?.comments?.length || 0;
        this.attachmentCount = this.data?.attachments?.length || 0;

        this.shipmentMethodDDL.dataSource = [{
          text: this.purchaseOrderData.shipmentMethodDescription,
          value: this.purchaseOrderData?.shipmentMethodCode
        }]

        this.showLoader = false;
      } else {
        this.commonService.showNotification('error', res[0].message);
        this.showLoader = false;
      }
    }, error => {
      this.commonService.showNotification('error', error.message);
      this.showLoader = false;
    })
  }
  
  shipPurchaseOrder() {
    this.showLoader = true;
    this.commonService.updatePurchaseOrderStatusToShipped(this.purchaseOrderData?.partsOrderId).subscribe({
      next: (res: any) => {
        if(res?.isSuccessful) {
          this.commonService.showNotification("success", res?.message);
          this.reload();
        } else {
          this.commonService.showNotification("error", res?.message);
        }
        this.showLoader = false;
      },
      error: (err: any) => {
        this.commonService.showNotification("error", "Could not complete this action!");
        this.showLoader = false;
      },
    })
  }

  getShipmentDDL() {
    this.iscService.getShippingMethodDDL(this.totalNetPrice).subscribe((res: ApiResponse) => {
      if (res.isSuccessful) {
        this.shipmentDDLFlag = true;
        this.shipmentMethodsList = res?.result;
        if (this.purchaseOrderData?.partsOrderId) {
          setTimeout(() => {
            this.shipmentMethodDDL.value = this.purchaseOrderData?.shipmentMethodCode;
            this.purchaseOrderData.shipmentMethodDescription = this.shipmentMethodDDL?.text;
          }, 1000);
        }
      }
      else {
        this.commonService.showNotification('warning', res.message + ' for shipment method')
        this.shipmentMethodsList = [];
        this.showLoader = false;
      }
    })
  }

  getShipmentCost(shipmentMethod) {
    if (shipmentMethod) {
      this.iscService.getShippingCost(shipmentMethod.itemData.value, shipmentMethod.itemData.description, this.totalNetPrice).subscribe((res: any) => {
        this.shippingCost = res?.result?.shippingCost
        this.purchaseOrderData['shippingCost'] = this.shippingCost;
        this.cdr.detectChanges()
      })
    }
  }

  setGrid() {
    this.mainGrid = {
      toolbar: []
    };
  }

  reload() {
    this.getPurchaseOrderById();
  }

  setAddress(addr) {
    const { address, name: addressName, addressCode, city, state, stateProvince, zipCode, country } = addr;

    this.purchaseOrderData = {
      ...this.purchaseOrderData,
      address,
      addressName,
      addressCode,
      city,
      state: state ?? stateProvince,
      zipCode,
      country,
      telephone: this.onsiteAddress?.telephone, // Preserve the logic using onsiteAddress for the telephone field
    };
  }

  //-------------------------------------- grids (@inavista/components) --------------------------------
  // The rows are this popup's own arrays (LocalRowsGridApi, no endpoint). Each grid row carries rowId, its index in
  // that array, so the row actions and links reach the popup's own object, as Syncfusion's rowData did.

  setupGrids() {
    // The status pill of getPurchaseOrdersClass. Its 'dark-orange' (Partially Shipped) is the coral pill (#FF7F50).
    const statusColor = statusPillColor(status => {
      const pill = this.commonService.getPurchaseOrdersClass(status);
      return pill === 'dark-orange' ? 'coral' : pill;
    });
    this.checkoutItemsConfig = buildCheckoutItemsGridConfig();
    this.checkoutItemsActionIcons = buildCheckoutItemsActionIcons(() => this.deleteItemLockReason());
    this.orderedItemsConfig = buildOrderedItemsGridConfig(statusColor);
    this.orderedItemsActionIcons = buildCancelActionIcons(row => this.orderedItemCancelLockReason(row));
    this.trackingUpdatesConfig = buildTrackingUpdatesGridConfig(statusColor, this.trackingIdCell);
    // The Cancel command showed for Service Managers and CSAs only, as before.
    this.trackingUpdatesActionIcons = (this.isSM || this.isCSA) ? buildCancelActionIcons(row => this.trackingCancelLockReason(row)) : [];
    this.refreshCheckoutRows();
    this.refreshOrderedRows();
    this.refreshTrackingRows();
  }

  // The items being ordered: recievedItems without the deleted ones (the old grid's query isDeleted = false).
  refreshCheckoutRows() {
    this.checkoutRowItems = Array.isArray(this.recievedItems) ? this.recievedItems : [];
    const rows = this.checkoutRowItems.map((item, rowId) => ({ ...item, rowId })).filter(row => row['isDeleted'] !== true);
    this.gridRows.set(CHECKOUT_ITEMS_URL, LocalRowsGridApi.schema(CHECKOUT_ITEMS_COLUMNS), rows);
    this.grid?.refresh();
  }

  refreshOrderedRows() {
    this.orderedRowItems = Array.isArray(this.orderedTabDataSource) ? this.orderedTabDataSource : [];
    this.gridRows.set(ORDERED_ITEMS_URL, LocalRowsGridApi.schema(ORDERED_ITEMS_COLUMNS), this.orderedRowItems.map((item, rowId) => ({ ...item, rowId })));
    this.orderedGridHeight = gridHeightFor(this.orderedRowItems.length);
    this.orderedItemGrid?.refresh();
  }

  refreshTrackingRows() {
    this.trackingRowItems = Array.isArray(this.trackingTabDataSource) ? this.trackingTabDataSource : [];
    this.gridRows.set(TRACKING_UPDATES_URL, LocalRowsGridApi.schema(TRACKING_UPDATES_COLUMNS), this.trackingRowItems.map((item, rowId) => ({ ...item, rowId })));
    this.trackingGridHeight = gridHeightFor(this.trackingRowItems.length);
    this.trackingGrid?.refresh();
  }

  /** The popup's own object behind a grid row. */
  recievedItemFor(row: GridRow) {
    return this.checkoutRowItems[row?.['rowId'] as number] ?? row;
  }

  orderedItemFor(row: GridRow) {
    return this.orderedRowItems[row?.['rowId'] as number] ?? row;
  }

  trackingItemFor(row: GridRow) {
    return this.trackingRowItems[row?.['rowId'] as number] ?? row;
  }

  // Item and Description open the item, as before.
  onItemHyperlinkClick(event: GridHyperlinkClickEvent, item: any) {
    this.showMasterItemCodePopup(item);
  }

  // Delete Item: the same handler as before, on the popup's own object. A disabled icon does nothing, as before.
  onCheckoutItemsActionIconClick(event: GridActionIconClickEvent) {
    if (this.deleteItemLockReason()) { return; }
    this.onCommandClick({ commandColumn: { title: event.iconKey }, rowData: this.recievedItemFor(event.row) });
  }

  onOrderedItemsActionIconClick(event: GridActionIconClickEvent) {
    if (this.orderedItemCancelLockReason(event.row)) { return; }
    this.onCommandColumnClickOrderedItems({ commandColumn: { title: event.iconKey }, rowData: this.orderedItemFor(event.row) });
  }

  // The old rowDataBound rules, as a reason (the icon's tooltip) or null when the action is enabled.

  // Delete Item: not the only item, not a paid order, not after the last item was deleted.
  deleteItemLockReason(): string | null {
    if (this.deleteDisableFlag) { return 'The only item of the order cannot be deleted.'; }
    if (this.purchaseOrderData?.paymentStatus === 'Paid') { return 'The order is paid: its items cannot be deleted.'; }
    if (this.noOrderFlag) { return 'The order has no items left.'; }
    return null;
  }

  // Ordered Items → Cancel: not on a shipped or cancelled line, nor on an In Progress line for the ISC roles.
  orderedItemCancelLockReason(row: GridRow): string | null {
    const status = row?.['status'];
    if (status === 'Canceled') { return 'This line is already cancelled.'; }
    if (status === 'Shipped') { return 'A shipped line cannot be cancelled.'; }
    if ((this.isIsc || this.isIscManager || this.isIscSupervisor) && status === 'In Progress') { return 'A line in progress cannot be cancelled.'; }
    return null;
  }

  // Tracking Updates → Cancel: not on an In Progress, shipped or cancelled line.
  trackingCancelLockReason(row: GridRow): string | null {
    const status = row?.['status'];
    if (status === 'Canceled') { return 'This line is already cancelled.'; }
    if (status === 'In Progress' || status === 'Shipped') { return 'A line in progress or shipped cannot be cancelled.'; }
    return null;
  }

  // -------------------------------------- command clicks --------------------------------

  onCommandClick(args) {
    if (args.commandColumn.title === 'Delete Item') {
      this.showLoader = true;
      this.commonService.showConfirmation('Are you sure to delete this item?')
        .then(result => {
          if (result.isConfirmed) {
            args.rowData.isDeleted = true;
            args.rowData.isSelected = false;
            this.iscService.deleteItemFromCart(args.rowData).subscribe((res: ApiResponse) => {
              this.iscService.getUserCartItem().subscribe((res: ApiResponse) => {
                this.totalNetPrice = this.tax = 0;
                this.purchaseOrderData.itemList = res.result;
                this.purchaseOrderData.itemList.forEach((item: any, index) => {
                  item.lineNumber = index + 1;
                  item.itemTotal = item.netPrice * item.quantity;
                  this.totalNetPrice += item.netPrice * item.quantity;
                  if (item.lineNumber === this.purchaseOrderData.itemList.length) {
                    this.tax = this.totalNetPrice * (this.taxRatePercentage / 100);
                    this.shipmentMethodDDL.dataSource = [];
                    this.getShipmentDDL();
                    this.getShipmentCost(this.shipmentargs);
                  }
                })
                if (!this.purchaseOrderData.itemList?.length) {
                  this.noOrderFlag = true;
                  this.purchaseOrderData.shippingCost = 0;
                }
                this.cdr.detectChanges();
                this.showLoader = false;
              })
            })
            this.refreshCheckoutRows();
          }
          else {
            this.showLoader = false;
          }
        });
    }
  }

  onCommandColumnClickOrderedItems(args) {
    if (args.commandColumn.title === 'Cancel') {
      this.commonService.showConfirmation('Are you sure? Cancelling the order will cancel all the item lines and cannot be reverted!')
        .then(result => {
          this.showLoader = true;
          if (result.isConfirmed) {
            if (this.isSM || this.isCSA || this.isIscManager || this.isIscSupervisor) {
              args.rowData.status = 'Canceled';
              this.iscService.updatePurchaseOrder(this.purchaseOrderData).subscribe((res: ApiResponse) => {
                this.getPurchaseOrderById();
                this.refreshOrderedRows();
                this.showLoader = false;
              })
            }
          }
          else {
            this.showLoader = false;
          }
        });
    }
  }

  onPaymentMethodChange(args) {
    this.purchaseOrderData.paymentMethod = args.value;
  }

  onAddressChange(args) {
    if (args?.itemData) {
      this.purchaseOrderData['address'] = args.itemData.address;
      this.purchaseOrderData['addressName'] = args.itemData.name;
      this.purchaseOrderData['addressCode'] = args.itemData.addressCode;
      this.purchaseOrderData['city'] = args.itemData.city;
      this.purchaseOrderData['state'] = args.itemData.stateProvince;
      this.purchaseOrderData['zipCode'] = args.itemData.zipCode;
      this.purchaseOrderData['country'] = args.itemData.country;
      this.purchaseOrderData['email'] = args.itemData.eMail;
      this.purchaseOrderData['telephone'] = this.onsiteAddress?.telephone; // why onsiteAddress???
    }
  }

  onShipmentMethodChange(args) {
    if (!this.purchaseOrderData?.partsOrderId) {
      this.shipmentargs = args;
      this.getShipmentCost(args);
      this.purchaseOrderData['shipmentMethodCode'] = args.value;
      this.purchaseOrderData['shipmentMethodDescription'] = args.text;
      this.purchaseOrderData['amount'] = this.totalNetPrice;
      this.purchaseOrderData['tax'] = this.tax;
    }
  }

  getTechnicianAddress() {
    this.iscService.getTechnicianAddress(this.purchaseOrderData?.partsOrderId ? this.purchaseOrderData?.technicianId : this.userDetails?.employeeId)
      .subscribe((res: any) => {
        this.technicianAddresses = res?.result;
        let address;
        if (this.checkType != 'onSiteAdress') {
          if (this.purchaseOrderData.partsOrderId) {
            address = this.technicianAddresses?.find(x => x.addressCode === this.purchaseOrderData.addressCode);
          } else {
            address = this.technicianAddresses[0];
          }
          if (address) {
            this.updatePODataAddress(address);
            this.showLoader = false;
          }
        }
      })
  }

  //------------------------------------- payment handling -------------------------------------

  ccPaymentCompleted(eventArgs) {
    this.showLoader = true;
    this.showChasePaymentIframe = false;
    this.cdr.detectChanges();
    this.showLoader = false;
    this.reload();
  }

  ccPaymentAuthcode(eventArgs) {
    this.disablePaymentButton = true;
  }

  ccPaymentCancel(eventArgs) {
    this.showChasePaymentIframe = false;
    // this.showCartCheckoutPopup = false;
    this.onClose.emit();
    this.cdr.detectChanges();
    this.showLoader = false;
  }

  radioButtonChanged(args) {
    const address = args.value === 'onSiteAddress' ? this.onsiteAddress : this.technicianAddresses[0];
    this.updatePODataAddress(address);
  }

  updatePODataAddress(addDetail) {
    this.purchaseOrderData = {
      ...this.purchaseOrderData,
      address: addDetail.address,
      addressName: addDetail.name,
      addressCode: addDetail.addressCode,
      city: addDetail.city,
      state: addDetail.stateProvince,
      zipCode: addDetail.zipCode,
      country: addDetail.country,
      email: addDetail?.eMail,
      telephone: addDetail.telephone
    }
  }

  setPurchaseOrderData() {
    if (!this.purchaseOrderData) {
      this.purchaseOrderData = {
        partsOrderId: '',
        alternatePORef: '',
        status: "Open",
        parentStatus: "Open",
        company: this.userDetails.company,
        technicianId: this.userDetails.employeeId,
        technicianName: this.userDetails.employeeName,
        warehouse: this.userDetails.warehouse,
        orderCurrency: this.userDetails.orderCurrency,
        createdBy: this.userDetails.employeeId,
        createdByName: this.userDetails.employeeName,
        lastUpdatedBy: this.userDetails.employeeName,
        lastUpdatedByName: this.userDetails.employeeName,
        serviceOrderId: "",
        priority: null,
        itemList: this.recievedItems,
        estimatedDeliveryDate: null,
        warehouseOrderLN: null,
        addressType: "technician", //for now technician, needs to apply on change
        notes: "",
        paymentStatus: 'Unpaid',
        shippingCost: this.shippingCost ? this.shippingCost : 0,
        tax: this.tax ? this.tax : 0,
        amount: this.totalNetPrice ? this.totalNetPrice : 0,
        comments: [],
        attachments: []
      };
    }
    this.serviceOrderId ? this.updatePODataAddress(this.onsiteAddress) : null;
  }

  validate() {
    return this.purchaseOrderData?.shipmentMethodCode;
  }

  onAttachmentsUpdate(data: any) {
    this.data.attachments = data;
    this.attachmentCount = data.filter(attachment => !attachment.isDeleted).length;
  }

  onCommentUpdate(data: any) {
    this.commentCount = data.filter(comment => !comment.isDeleted).length;
  }

  submitOnly() {
    if (this.purchaseOrderData.partsOrderId) {
      this.showLoader = true;
      this.purchaseOrderData.paymentStatus = "Paid";
      this.purchaseOrderData.status = "Submitted";
      this.purchaseOrderData['totalAmount'] = this.purchaseOrderData.amount + this.shippingCost + this.tax;
      if (this.serviceOrderId) {
        this.purchaseOrderData['serviceOrderId'] = this.serviceOrderId;
      }
      const items = this.purchaseOrderData.itemList;
      items.forEach(el => {
        el.status = 'Submitted'
      });
      this.iscService.updatePurchaseOrder(this.purchaseOrderData).subscribe((res: ApiResponse) => {
        if (res.isSuccessful) {
          this.getPurchaseOrderById();
          this.refreshOrderedRows();
          this.commonService.showNotification('success', 'Purchase order "' + res.result.partsOrderId + '" updated!');
          this.showLoader = false;
        }
        else {
          this.commonService.showNotification('warning', 'Order not updated!');
        }
      })
    }
    else if (this.validate() && this.purchaseOrderData.itemList.length) {
      this.commonService.showConfirmation('Do you want to create order?')
        .then(result => {
          if (result.isConfirmed) {
            this.showLoader = true;
            this.purchaseOrderData.paymentStatus = "Paid";
            this.purchaseOrderData.status = "Submitted";
            this.purchaseOrderData['totalAmount'] = this.purchaseOrderData.amount + this.shippingCost + this.tax;
            if (this.serviceOrderId) {
              this.purchaseOrderData['serviceOrderId'] = this.serviceOrderId;
            }
            this.iscService.createIscPurchaseOrder(this.purchaseOrderData).subscribe((res: ApiResponse) => {
              if (res.isSuccessful) {
                this.commonService.showNotification('success', 'Purchase order "' + res.result.partsOrderId + '" created!');
                this.showLoader = false;
                if (this.serviceOrderId) {
                  this.iscService.resetCartCount(true);
                }
                this.onClose.emit();
              }
              else {
                this.commonService.showNotification('warning', 'Purchase Order is not created!');
                this.showLoader = false;
                this.onClose.emit();
              }
            })
          }
        });
    }
    else {
      this.commonService.showNotification('error', 'Please fill the required fields');
    }

  }

  payAndSubmit() {
    if (this.validate() && this.purchaseOrderData.itemList.length) {
      if (this.purchaseOrderData.partsOrderId && this.purchaseOrderData.partsOrderId !== null) {
        this.purchaseOrderId = this.purchaseOrderData.partsOrderId
        this.data = {
          invoiceAmount: this.purchaseOrderData.amount + this.shippingCost + this.tax,
          customerCurrency: this.purchaseOrderData.orderCurrency,
          customerEmail: this.userDetails.email,
          address: this.purchaseOrderData.address,
          city: this.purchaseOrderData.city,
          state: this.purchaseOrderData.state,
          zipcode: this.purchaseOrderData.zipCode,
          customerPhoneNumber: this.purchaseOrderData.phoneNumber,
        }
        this.showChasePaymentIframe = true;
      }
      else {
        this.commonService.showConfirmation('Do you want to create order?').then(result => {
          if (result.isConfirmed) {
            this.showLoader = true;
            this.purchaseOrderData.status = "Payment Pending";
            if (this.serviceOrderId) {
              this.purchaseOrderData['serviceOrderId'] = this.serviceOrderId;
            }
            this.iscService.createIscPurchaseOrder(this.purchaseOrderData
            ).subscribe((res: ApiResponse) => {
              this.purchaseOrderId = res.result.partsOrderId
              this.data = {
                invoiceAmount: this.purchaseOrderData.amount + this.shippingCost + this.tax,
                customerCurrency: this.purchaseOrderData.orderCurrency,
                customerEmail: this.userDetails.email,
                address: this.purchaseOrderData.address,
                city: this.purchaseOrderData.city,
                state: this.purchaseOrderData.state,
                zipcode: this.purchaseOrderData.zipCode,
                customerPhoneNumber: this.purchaseOrderData.phoneNumber,
              }
              if (res.isSuccessful) {
                this.commonService.showNotification('success', 'Purchase order "' + res.result.partsOrderId + '" created!');
                this.showChasePaymentIframe = true;
              }
              else {
                this.commonService.showNotification('warning', 'Order not created');
              }
            })
            this.showLoader = false;
          }
          else {
            return;
          }
        });
      }
    }
    else {
      this.commonService.showNotification('error', 'Please fill all the fields');
    }
  }

  close() {
    if ([PurchaseOrderStatus.shipped, PurchaseOrderStatus.submitted].includes(this.purchaseOrderData.status)) {
      this.refreshCheckoutRows();
      this.iscService.resetCartCount(true);
      this.onClose.emit();
      this.showLoader = false;
    } else {
      let confirmationMessage = 'Are you sure?\n This order details will be lost.';
      this.commonService.showConfirmation(confirmationMessage)
        .then(result => {
          if (result.isConfirmed) {
            if (this.recievedItems[0]?.comingFrom) {
              this.recievedItems = [];
            }
            // Fixed (Martin, 2026-10-28): this.grid.refresh() threw when the grid was not shown yet (closing before the items loaded).
            this.refreshCheckoutRows();
            this.onClose.emit();
            this.iscService.resetCartCount(true);
            this.showLoader = false;
          }
        });
    }
  }

  redirectToTracking(data) {
    window.open(data.trackingLink, '_blank');
  }

}
